<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title> {{ "Filtrar" | translate }}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="ion-margin-top">
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-list>
        <ng-container>
          <prover-datepicker
            [labelName]="'Data Início'"
            [id]="'dataInicio'"
            formControlName="dataInicio"
          ></prover-datepicker>
        </ng-container>

        <ng-container>
          <prover-datepicker
            [labelName]="'Data Fim'"
            [id]="'dataFim'"
            formControlName="dataFim"
          ></prover-datepicker>
        </ng-container>

        <ion-row class="prover-datepicker">
          <ion-col size="12" class="remove-border">
            <ion-item>
              <ion-select
                labelPlacement="stacked"
                interface="action-sheet"
                label="{{ 'Status' | translate }}"
                placeholder="{{ 'Status' | translate }}"
                cancelText="{{ 'Cancelar' | translate }}"
                okText="{{ 'Confirmar' | translate }}"
                formControlName="status"
              >
                <ion-select-option
                  *ngFor="let filter of status"
                  [value]="filter.id"
                  >{{ filter.label }}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <div class="down">
          <ion-button
            class="btn-default"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid"
          >
            {{ "Filtrar" | translate }}
          </ion-button>
        </div>
      </ion-list>
    </form>
  </div>
</ion-content>
